import { Component, inject, AfterViewInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import {
  AsignRoleOrActionCreateModalComponent,
  RoleActionService,
} from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UpperCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  templateUrl: './role-action-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    UpperCasePipe,
  ],
})
export class RoleActionPageComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [
    'code',
    'name',
    'description',
    'type',
    'options',
  ];
  dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  fielInput!: string;
  private dialog = inject(MatDialog);
  private roleActionService = inject(RoleActionService);
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  modalAction(action?: any) {
    const dialogActionDetail = this.dialog.open(
      AsignRoleOrActionCreateModalComponent,
      {
        width: '50%',
        data: {
          action: action,
        },
        disableClose: true,
      }
    );
    dialogActionDetail.beforeClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
    });
  }
}

const ELEMENT_DATA: any = [
  {
    id: 1,
    code: 'WJR',
    name: 'LS',
    description: 'neque duis bibendum morbi',
    type: 'application/x-excel',
  },
  {
    id: 2,
    code: 'IXV',
    name: 'Rodeo',
    description: 'augue vestibulum',
    type: 'audio/x-mpeg-3',
  },
  {
    id: 3,
    code: 'BSY',
    name: 'F250',
    description: 'et eros vestibulum',
    type: 'audio/x-mpeg-3',
  },
  {
    id: 4,
    code: 'SAH',
    name: '900',
    description: 'habitasse platea dictumst morbi',
    type: 'video/msvideo',
  },
  {
    id: 5,
    code: 'USH',
    name: 'Regal',
    description: 'morbi vel lectus in',
    type: 'application/powerpoint',
  },
  {
    id: 6,
    code: 'BDG',
    name: 'S6',
    description: 'quisque ut erat curabitur gravida nisi',
    type: 'application/pdf',
  },
  {
    id: 7,
    code: '0',
    name: 'Metro',
    description: 'diam id ornare imperdiet sapien',
    type: 'video/msvideo',
  },
  {
    id: 8,
    code: 'PHP',
    name: 'RAV4',
    description: 'id turpis integer aliquet massa',
    type: 'application/powerpoint',
  },
  {
    id: 9,
    code: 'PNH',
    name: 'Caliber',
    description: 'convallis nunc proin at',
    type: 'application/vnd.ms-powerpoint',
  },
  {
    id: 10,
    code: 'CWL',
    name: 'Quest',
    description: 'sapien ut nunc vestibulum ante',
    type: 'audio/mpeg3',
  },
  {
    id: 11,
    code: 'AML',
    name: 'Tacoma Xtra',
    description: 'sed sagittis nam congue risus',
    type: 'application/msword',
  },
  {
    id: 12,
    code: 'ADL',
    name: '4Runner',
    description: 'non pretium',
    type: 'application/excel',
  },
  {
    id: 13,
    code: 'YTJ',
    name: 'Continental GTC',
    description: 'duis ac nibh fusce lacus purus',
    type: 'application/x-troff-msvideo',
  },
  {
    id: 14,
    code: 'SNC',
    name: 'Grand Marquis',
    description: 'aliquam quis turpis',
    type: 'application/vnd.ms-excel',
  },
  {
    id: 15,
    code: 'DPG',
    name: 'Trooper',
    description: 'amet nunc viverra dapibus nulla suscipit',
    type: 'image/pjpeg',
  },
  {
    id: 16,
    code: 'ADS',
    name: 'ES',
    description: 'sed augue',
    type: 'video/msvideo',
  },
  {
    id: 17,
    code: 'UYN',
    name: 'Sentra',
    description: 'malesuada in imperdiet et commodo vulputate',
    type: 'video/avi',
  },
  {
    id: 18,
    code: 'IRS',
    name: 'A8',
    description: 'dui maecenas',
    type: 'video/msvideo',
  },
  {
    id: 19,
    code: 'DMD',
    name: 'Pilot',
    description: 'quam pede lobortis ligula sit amet',
    type: 'image/pjpeg',
  },
  {
    id: 20,
    code: 'ORR',
    name: 'Odyssey',
    description: 'etiam pretium',
    type: 'video/mpeg',
  },
];
